import {AuthEffects} from '../auth/store/auth.effect';
import {LayoutEffects} from '../layout/store/layout.effects';
export const effects = [AuthEffects, LayoutEffects];
